import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TheyUseVideoSenseComponent } from '@app/layout/they-use-video-sense/they-use-video-sense.component';
import { BannerComponent } from './banner/banner.component';
import { StockFootageComponent } from './stock-footage/stock-footage.component';
import { PopularCategoriesComponent } from './popular-categories/popular-categories.component';
import { PopularSearchRequestsComponent } from './popular-search-requests/popular-search-requests.component';
import { MetaService } from '@app/core/services/meta.service';

@Component({
  selector: 'app-index-page',
  templateUrl: './index.page.html',
  styleUrls: ['./index.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    StockFootageComponent,
    PopularCategoriesComponent,
    PopularSearchRequestsComponent,
    BannerComponent,
    TheyUseVideoSenseComponent,
  ],
})
export class IndexPage implements OnInit {
  constructor(private metaService: MetaService) {}

  ngOnInit(): void {
    const metadata = {
      title: 'videosense.net – Stunning Stock Videos for Creative Projects',
      description:
        'Explore a vast collection of high-resolution stock videos. Download professional videos for business, design, and marketing needs.',
      keywords:
        'stock videos, high-quality videos, stock photography, professional videos, royalty-free videos, commercial photos, high-resolution videos',
    };

    this.metaService.setMetadata(metadata);
  }
}
